import PillarForm from "shared/components/pillar-form/PillarForm";
import { useCustomRouter } from "shared/context/CustomRouterContext";
import { useHubReviewsVotingPageContext } from "hub/src/context/reviews/HubReviewsVotingPageContext";

export const HubReviewsVotingNavigationButtons = () => {
  const router = useCustomRouter();
  const {
    reviewSession,
    recusalModalControl,
    nextInstanceId,
    previousInstanceId,
  } = useHubReviewsVotingPageContext();

  if (!nextInstanceId && !previousInstanceId) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <div className="mb-1 flex items-center justify-between">
        <PillarForm.Button
          disabled={previousInstanceId == null}
          onClick={() =>
            router.push(
              `/reviews/${reviewSession.id}/instance/${previousInstanceId}`,
            )
          }
          className="px-3 button-review-voting-action"
          title="Back"
          data-testid="backButton"
        >
          Back
        </PillarForm.Button>
        {reviewSession.allowRecusals && (
          <PillarForm.Button
            onClick={() => recusalModalControl.setIsOpen(true)}
            className="px-3 bg-status-danger-tint hover:bg-status-danger"
            title="Recuse"
            label="Recuse"
            data-testid="recuseButton"
          />
        )}
        <PillarForm.Button
          disabled={nextInstanceId == null}
          className="px-3 button-review-voting-action"
          title="Skip"
          data-testid="skipButton"
          onClick={() =>
            router.push(
              `/reviews/${reviewSession.id}/instance/${nextInstanceId}`,
            )
          }
        >
          Next
        </PillarForm.Button>
      </div>
    </div>
  );
};
